export function buildDeleteUserConfirmMessage(username) {
  return `确定要删除用户 "${username}" 吗？`;
}

export function buildUserDeletedSuccessMessage() {
  return '用户已删除';
}

export function buildUserRoleUpdatedSuccessMessage() {
  return '角色已更新';
}

export function buildUserSeedSuccessMessage(createdCount, message) {
  if (message) return message;
  return `已创建 ${createdCount} 个用户（临时密码请以接口返回为准）`;
}

export function buildUserSeedFailedMessage(error) {
  return error || '初始化失败';
}

export function buildUserSeedExceptionMessage(errorMessage) {
  return errorMessage || '请求失败，请检查网络或后端服务';
}

export function buildSaveFailedMessage(error) {
  return error || '保存失败';
}

export function buildAuditRoleUnavailableMessage() {
  return '审计角色未保存：服务器数据库尚未支持该字段，请在服务器执行 npx prisma migrate deploy';
}

export function buildAuditGroupUnavailableMessage() {
  return '审计组未保存：服务器数据库尚未支持，请执行 npx prisma migrate deploy 与 npx prisma generate';
}

export function buildTempConfigAuditGroupRequiredMessage(username) {
  return `请先为 ${username} 分配归属部门后再保存`;
}

export function buildTempConfigSaveFailedMessage(username, error) {
  return `保存 ${username} 配置失败：${error}`;
}

export function buildTempConfigSaveSuccessMessage(username) {
  return `${username} 保存配置成功`;
}

export function buildTempConfigSaveSuccessAlertMessage() {
  return '保存配置成功';
}

export function buildApplyTemplateSelectFirstMessage() {
  return '请选择模板后再应用';
}

export function buildPreviewTemplateSelectFirstMessage() {
  return '请选择模板后再预览';
}

export function buildPreviewTemplateSelectUsersFirstMessage() {
  return '请先勾选要批量预览的账号';
}

export function buildApplyTemplateSelectUsersFirstMessage() {
  return '请先勾选要批量应用模板的账号';
}

export function buildBatchTemplateSelectFirstMessage() {
  return '请先选择批量模板';
}

export function buildBatchCreateUsersSuccessMessage(count) {
  return `成功创建 ${count} 个用户`;
}

export function buildCreateUserSuccessMessage() {
  return '用户创建成功';
}

export function buildUpdateUserSuccessMessage() {
  return '用户已更新';
}

export function buildResetUserPasswordSuccessMessage() {
  return '密码已重置';
}
